import { useSelector } from 'react-redux';
import { Network } from '@kattana-io/common';
import PoolRow from '../PoolRow';
import { PoolWidgetRow } from '../helpers/rows';
import { IStore } from '../../../reducers';
import { ICurrentState } from '../../../reducers/current';

import './styles.scss';

interface IPoolScoreProps {
  rows: PoolWidgetRow[];
  current: ICurrentState;
}

const PoolScore = ({ rows, current }: IPoolScoreProps) => {
  const timezone = useSelector((state: IStore) => state.timezone.current);

  const network = Network.fromChain(current.chain);

  return (
    <div className='pool_score'>
      {rows.map((row) => (
        <PoolRow key={row.id} row={row} network={network} timezone={timezone} />
      ))}
    </div>
  );
};

export default PoolScore;
